/*Method for submit a form that is received as parameter*/
function submitForm(formToSubmit) {
    if (formToSubmit !== null) {
        formToSubmit.submit();
    }
    else {
        window.location.href = document.referrer;
    }
};
/*Method for submit a form that is received as the second parameter when the a button that is received as the first parameter is clicked*/
function modalConfirmationMemo(yesButton, formMemo) {
    if (yesButton !== null && formMemo !== null) {
        yesButton.click(function () {
            submitForm(formMemo);
        });
    };
};

var yesButtonDealOverview = $("#deal-overview-yes-buttton");
var backButton = $("#back-button");
/*Back button functionality*/
if (backButton !== null) {
    backButton.click(function () {
        var formBack = $("#back-form");
        var textBoxMemo = $("#text-box-memo");
        if (textBoxMemo !== null) {
            var textMemoValue = textBoxMemo.val();
            // Checks if the textbox of memo have text to open the cofirmation modal
            if (textMemoValue !== undefined && textMemoValue !== "") {
                $("#back-confirmation-modal").modal();
                modalConfirmationMemo(yesButtonDealOverview, formBack);
            }
            else {
                submitForm(formBack);
            }
        }
        else {
            submitForm(formBack);
        }
    });
};